<div class="wrapper-inner">
  <div class="main-content">
    <ng-container *ngTemplateOutlet="mobileDevice ? mobileView: (tabletDevice ? tableView : desktopView)"></ng-container>
  </div>
</div>

<ng-template #desktopView>
  <div class="order-settings__subnav container font-5 my-3" >
    <div class="row px-0">
      <app-cart-select [allowAdd]="true"></app-cart-select>

      <span class="right sap-title" *ngIf="activeOrder && canShowOrderSettings">
        <button class="m-lg-1 btn btn-outline-primary" (click)="editOrderSettings()" title="Edit">EDIT ORDER INFO</button>
      </span>
    </div>
  </div>

  <!-- product detail page -->
  <app-hero *ngIf="heroSlides" [slides]="heroSlides" ></app-hero>
  <app-breadcrumb *ngIf="product" productLabel="{{product.label}}"></app-breadcrumb>

  <div *ngIf="product" class="product-details container">
    <div class="product-details__upper">
      <div class="product-details--gallery">
        <product-gallery [product]="product" ></product-gallery>
      </div>

      <div class="product-details--options">
        <app-product-order-item viewType="detailed" *ngIf="activeOrder"
                                [product]="product"
                                [order]="activeOrder"
                                [showBudget]="true"
                                (changed)="onOrderItemChanged($event)"
                                >
        </app-product-order-item>
      </div>
    </div>

    <div class="product-details__lower">
      <product-details [product]="product"></product-details>
    </div>

    <div class="product-details__related" *ngIf="relatedPids &&  products.length > 0">
      <products-grid-related  [products]="products" [order]="activeOrder"></products-grid-related>
    </div>
  </div>
</ng-template>

<ng-template #mobileView>
  <div class="container">
    <div class="order-settings__subnav font-5 my-3" >
      <div class="d-flex align-items-center justify-content-between">
        <app-cart-select [allowAdd]="true" [mobile]="true"></app-cart-select>

        <span class="right sap-title" *ngIf="activeOrder && canShowOrderSettings">
          <button class="btn btn-icon with-shadow with-border btn-order-edit" (click)="editOrderSettings()" title="Edit">
            <i class="fal fa-edit"></i>
          </button>
        </span>
      </div>
    </div>

    <ng-container *ngIf="product">
      <div class="d-md-block">
        <span *ngIf="isItemCut" class="text-danger font-weight-bold">{{ 'This item has been cut' | uppercase }}</span>
        <h1 class="product-label color--primary-blue my-0" [innerHTML]="product.label | safeContent "></h1>
      </div>

      <!-- product detail page -->
      <div *ngIf="product" class="product-details mt-3">
        <div class="product-details__upper">
          <div class="product-details--gallery mx-auto mb-3">
            <product-gallery  [product]="product" ></product-gallery>
          </div>

          <div class="product-details--options line-up-separator--light-grey pt-3">
            <app-product-order-item viewType="detailed" *ngIf="activeOrder"
                                    [product]="product"
                                    [order]="activeOrder"
                                    [showBudget]="true"
                                    (changed)="onOrderItemChanged($event)"
                                    >
            </app-product-order-item>
          </div>
        </div>


        <div class="product-details__lower">
          <product-details [product]="product"></product-details>
        </div>

        <div class="product-details__related line-up-separator--grey" *ngIf="relatedPids &&  products.length > 0">
          <products-grid-related  [products]="products" [order]="activeOrder"></products-grid-related>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #tableView>
  <div class="container">
    <div class="order-settings__subnav font-5 my-3" >
      <div class="d-flex align-items-center justify-content-between">
        <app-cart-select [allowAdd]="true" [mobile]="true"></app-cart-select>

        <span class="right sap-title" *ngIf="activeOrder && canShowOrderSettings">
          <button class="btn btn-icon with-shadow with-border btn-order-edit" (click)="editOrderSettings()" title="Edit">
            <i class="fal fa-edit"></i>
          </button>
        </span>
      </div>
    </div>

    <!-- product detail page -->
    <div *ngIf="product" class="product-details mt-3">
      <div class="product-details__upper">
        <div class="product-details--gallery mx-auto">
          <product-gallery [product]="product" ></product-gallery>
        </div>

        <div class="product-details--options">
          <app-product-order-item viewType="detailed" *ngIf="activeOrder"
                                  [product]="product"
                                  [order]="activeOrder"
                                  [showBudget]="true"
                                  (changed)="onOrderItemChanged($event)"
                                  >
          </app-product-order-item>
        </div>
      </div>


      <div class="product-details__lower">
        <product-details [product]="product"></product-details>
      </div>

      <div class="product-details__related" *ngIf="relatedPids &&  products.length > 0">
        <products-grid-related  [products]="products" [order]="activeOrder"></products-grid-related>
      </div>
    </div>
  </div>

</ng-template>

<app-footer></app-footer>
<app-back-top position="200"></app-back-top>
